import { SIZE as SIZE_ATTRIBUTES } from '../../../../molecules/attributes/scripts/consts'
import { SIZE as SIZE_CART } from '../../../../molecules/cart-button/scripts/consts'
import { SIZE as SIZE_FAVORITE } from '../../../../molecules/favorite/scripts/consts'
import { SLIDER_DOTS_SIZE } from '../../../../molecules/media/scripts/consts'
import { SIZE } from '../consts'

export const useSizes = (size) => {
  const sizes = computed(() => ({
    cart: {
      [SIZE.XS]: SIZE_CART.S,
      [SIZE.S]: SIZE_CART.S,
      [SIZE.M]: SIZE_CART.S,
      [SIZE.L]: SIZE_CART.M,
    }[unref(size)],

    favorite: {
      [SIZE.XS]: SIZE_FAVORITE.S,
      [SIZE.S]: SIZE_FAVORITE.S,
      [SIZE.M]: SIZE_FAVORITE.S,
      [SIZE.L]: SIZE_FAVORITE.M,
    }[unref(size)],

    sliderDots: {
      [SIZE.XS]: SLIDER_DOTS_SIZE.XXS,
      [SIZE.S]: SLIDER_DOTS_SIZE.XXS,
      [SIZE.M]: SLIDER_DOTS_SIZE.XXS,
      [SIZE.L]: SLIDER_DOTS_SIZE.XS,
    }[unref(size)],

    attributes: {
      [SIZE.XS]: SIZE_ATTRIBUTES.S,
      [SIZE.S]: SIZE_ATTRIBUTES.S,
      [SIZE.M]: SIZE_ATTRIBUTES.S,
      [SIZE.L]: SIZE_ATTRIBUTES.M,
    }[unref(size)],

    price: {
      [SIZE.XS]: {
        fontSize: 14,
        threshold: 6,
      },
      [SIZE.S]: {
        fontSize: 16,
        threshold: 6,
      },
      [SIZE.M]: {
        fontSize: 16,
        threshold: 9,
      },
      [SIZE.L]: {
        fontSize: 20,
        threshold: 9,
      },
    }[unref(size)],

    priceDiscount: {
      [SIZE.XS]: {
        fontSize: 12,
        lineHeight: 1.2,
        gap: 8,
      },
      [SIZE.S]: {
        fontSize: 12,
        lineHeight: 1.1,
        gap: 8,
      },
      [SIZE.M]: {
        fontSize: 14,
        lineHeight: 1.2,
        gap: 8,
      },
      [SIZE.L]: {
        fontSize: 14,
        lineHeight: 1.2,
        gap: 8,
      },
    }[unref(size)],
  }))

  return {
    sizes,
  }
}
